export default "__VITE_ASSET__CjDYylQI__"